import useIntercom from '@lib/hooks/useIntercom'
import useSharedData from '@lib/hooks/useSharedData'
import React, { ReactElement } from 'react'

interface IWithSharedData {
  children: React.ReactNode
}

const WithSharedData = ({ children }: IWithSharedData) => {
  useSharedData()
  useIntercom()

  return children
}

const withAuth =
  (Component) =>
  //eslint-disable-next-line
  ({
    isAuthenticated,
    children,
    ...rest
  }: {
    children: ReactElement
    isAuthenticated: boolean
  }) => {
    if (!isAuthenticated) return children
    return <Component {...rest}>{children}</Component>
  }

export default withAuth(WithSharedData)
